import styled from 'styled-components';
import COLORS from '../../common/styles/color-pallete';
import { FONT_FAMILY } from '../../common/styles/fontStyles';
import DEVICES from '../../common/styles/devices';

export const DetailsWrapper = styled.div<{ width?: string }>`
  width: ${({ width }): string => (width ? width : '450px')};
  padding: 12px 0 12px 0;
  border-top: 1px solid ${COLORS.lightGrey};
  border-bottom: 1px solid ${COLORS.lightGrey};
  .inner-wrapper {
    display: flex;
    justify-content: space-between;
  }
  .heading-wrapper {
    flex-direction: column;
  }
  .heading {
    font-family: ${FONT_FAMILY.hellix.bold};
    font-size: 14px;
    line-height: 26px;
    color: ${COLORS.black};
  }
  .subHeading {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 14px;
    line-height: 18px;
    color: ${COLORS.textLightGrey};
  }
  .extraInfo {
    font-family: ${FONT_FAMILY.hellix.regular};
    font-size: 12px;
    line-height: 16px;
    color: ${COLORS.textLightGrey};
  }
  .copyIcon {
    cursor: pointer;
    align-self: center;
  }
  @media ${DEVICES.mobileXL} {
    padding: 12px 20px;
    width: 100%;
  }
`;
